import Axios from 'axios';

function OrderByFullName(a, b){
    const nameA = `${a.Nom} ${a.prenom}`.toUpperCase(); // ignore upper and lowercase
    const nameB = `${b.Nom} ${b.prenom}`.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
  
    // names must be equal
    return 0;
}

export default class {
  constructor(token, baseURL, sourceSecteur = "SECTEUR") {
    this.headers = {
      token,
      baseURL,
      sourceSecteur,
    }
    this.api = Axios.create({
      baseURL: 'https://netsoins-proxy.anisen.fr/',
      headers: {
        ... this.headers,
        'accept': 'application/json;charset=UTF-8',
        'Content-Type': 'application/json'
      },
    });
  }

  async getJobs() {
    const { data } = await this.api.get('EstablishmentInfo/Jobs');
    return (data?.data ?? []).map(job => ({
      Uri: job.uri,
      Libelle: job.label,
    }));
  }

  /**
   * Pour le mapping avec les services
   */
  async getSectors() {
    const { data } = await this.api.get('EstablishmentInfo/Secteurs');
    return (data?.data ?? []).map(sector => ({
      Uri: sector.uri,
      Libelle: sector.label,
      Actif: "1",
    }));
  }

  async getPlaces() {
    const { data } = await this.api.get('EstablishmentInfo/Lieux');
    return (data?.data ?? []).map(place => ({
      Uri: place.uri,
      Libelle: place.label,
      Actif: "1",
    }));
  }

  async getResidents() {
    const { data } = await this.api.get('EstablishmentInfo/Residents');
    return (data?.data ?? [])
      .map(resident => ({
        Uri: resident.uri,
        Actif: resident.enabled ? "1" : "0",
        Genre: resident.genre ? "HOMME" : "FEMME",
        Nom: resident.lastName,
        Prenom: resident.firstName,
        DateNaissance: resident.birthDay,
      }))
      .sort(OrderByFullName);
  }

  async getStaffs() {
    const { data } = await this.api.get('EstablishmentInfo/Staffs');
    return (data?.data ?? [])
      .map(staff => ({
        Uri: staff.uri,
        Actif: staff.enabled ? "1" : "0",
        Genre: staff.genre ? "HOMME" : "FEMME",
        Nom: staff.lastName,
        Prenom: staff.firstName,
        CategorieProfessionnelle: {
          Uri: staff.externalJobUri,
        },
      }))
      .sort(OrderByFullName);
  }

  async getActivities() {
    const { data } = await this.api.get('EstablishmentInfo/AnimationAtelier');
    return (data?.data ?? []).map(activity => ({
      Uri: activity.uri,
      Libelle: activity.libelle,
    }));
  }

  async importCustomActivitiesFromLDS(esta_id, useProdConfig = false) {
    const { data } = await this.api.post('EstablishmentInfo/sync/Activities', {estaId: esta_id, useProdConfig});
    return data?.data ?? null;
  }
};
